import { EFinancingProgram } from '@if/core/types'
import { PageContainer, useIfUser } from '@if/mui'
import { Stack } from '@mui/material'
import { useMerchant } from '@src/containers/App/MerchantProvider'
import { useMerchantFinancingConfigQuery } from '@src/data/api/configs-api/financing-config-api'
import {
  useCustomBuydownPlansQuery,
  useCustomBuydownSwitchStatusQuery,
} from '@src/data/api/custom-buydown-api/custom-buydown-api'
import { useBorrowerContext } from '@src/hooks/borrower-context-hooks'
import { getPersonalMaxLoanAmount } from '@src/types/Constants'
import { useTranslation } from 'react-i18next'
import { CustomBuydownForm } from './components/CustomBuydownForm'
import { CustomBuydownSkeleton } from './components/CustomBuydownSkeleton'
import { CurrentPlanHistory, ExpiredPlansSection } from './components/PlanHistory'

const useCustomBuydownResources = () => {
  const user = useIfUser()
  return {
    plans: useCustomBuydownPlansQuery(user.merchantId),
    switchStatus: useCustomBuydownSwitchStatusQuery(user.merchantId),
    financingConfig: useMerchantFinancingConfigQuery(user.merchantId, EFinancingProgram.Personal),
  }
}

const CustomBuydownPage = () => {
  const { t } = useTranslation()
  const merchant = useMerchant()
  const context = useBorrowerContext()
  return (
    <PageContainer
      usePrimary={useCustomBuydownResources}
      title={t('customBuydown.title', { context })}
      subtitle={t('customBuydown.subtitle', { context })}
      loadingContent={<CustomBuydownSkeleton />}
    >
      {(data) => (
        <Stack spacing={3}>
          <CustomBuydownForm
            activePlan={data.plans[0] ?? null}
            merchantId={merchant.id}
            switchStatus={data.switchStatus}
            maxLoanAmount={getPersonalMaxLoanAmount(merchant.serviceCategory, data.financingConfig.maximumLoanAmount)}
          />
          {data.plans[0] && <CurrentPlanHistory merchantId={merchant.id} plan={data.plans[0]} />}
          <ExpiredPlansSection merchantId={merchant.id} />
        </Stack>
      )}
    </PageContainer>
  )
}

export default CustomBuydownPage
